export const getSelectedInstruction = (data, selectedInstructionSetId) => {
  return data.find(option => option.id === selectedInstructionSetId)
}

export const getPreviewSteps = (selectedInstruction, language) => {
  if (!selectedInstruction?.steps) return []

  return selectedInstruction.steps[language] || []
}

export const getHelperText = ({ instructionType, loading, hasOptions, t }) => {
  if (!instructionType) {
    return t('Selecciona un tipo de método de devolución para ver las instrucciones disponibles')
  }

  if (!loading && !hasOptions) {
    return t('No hay instrucciones de devolución disponibles para este tipo de método.')
  }

  return undefined
}
